import {
  contentServiceGet,
  contentServicePost,
} from 'infrastructure/contentService'
import { FileOwner, GDriveFile } from '../contentService/types'

export const RootFolderId = '1pT4eM9QX-7MnbcwLbo7CBKRjmuZbO9Ll'

export function groupFilesByOwner(files: GDriveFile[]) {
  return files.reduce<{
    owners: Record<string, FileOwner>
    ownerFiles: Record<string, GDriveFile[]>
  }>(
    ({ owners, ownerFiles }, file) => {
      owners[file.owners[0].emailAddress] = file.owners[0]
      ownerFiles[file.owners[0].emailAddress] =
        ownerFiles[file.owners[0].emailAddress] || []
      ownerFiles[file.owners[0].emailAddress].push(file)
      return {
        owners,
        ownerFiles,
      }
    },
    { owners: {}, ownerFiles: {} },
  )
}

export async function getFlowTag(folderId: string) {
  return contentServiceGet<{ flow_tag: string }>({
    path: `/content/v1/gdrive/folder/${folderId}/flow_tag`,
  })
}

export async function startFilesForFolderJob(
  folderId: string,
  googleAccessToken: string,
) {
  return contentServicePost({
    path: `/content/v1/gdrive/folder/${folderId}/files/process`,
    optionOverrides: {
      headers: { GAuthorization: googleAccessToken },
    },
  })
}

export async function transferFileOwnership(
  token: string,
  body: {
    new_owner_email: string
    file_ids: string | string[]
  },
) {
  return contentServicePost<{ data: { flow_id: string } }>({
    path: `/content/v1/gdrive/file_owner_transfer`,
    body,
    optionOverrides: {
      headers: { GAuthorization: token },
    },
  })
}
